<template>
    <rkm-modal
        :loading="loading"
        :title="`Subgrupos (${grupo.nome})`"
        persistent
        ref="Modal"
    >
        <rkm-table
            :fields="fields"
            :items="subgrupos"
            @filtered="subgruposFiltered = $event"
        > 
            <template #head(permiteControlar)="">
                <rkm-form-checkbox
                    :disabled="disabledSelectAll"
                    :indeterminate="indeterminate"
                    :value="true"
                    @change="selectAll"
                    v-model="selectedAll"
                />
            </template>

            <template v-slot:cell(permiteControlar)="{ item }">
                <rkm-form-checkbox
                    :disabled="item.hasPermissaoRequisicao"
                    :value="true"
                    v-model="item.permiteControlar"
                    v-rkm-tooltip="item.hasPermissaoRequisicao
                        ? 'Não é possível desmarcar este subgrupo porque ele possui permissões de requisição' : ''"
                />
            </template>
        </rkm-table>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

// Others.
import { object } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: 'permiteControlar',
                    label: 'Permite controlar',
                    class: 'col-min text-center'
                },
                {
                    key: 'nome',
                    label: 'Nome',
                    sortable: true,
                },
            ]
        },
        disabledSelectAll() {

            return !this.subgrupos
                .filter(sg => this.subgruposFiltered.find(sgf => sgf.id === sg.id))
                .find(sg => !sg.hasPermissaoRequisicao)
        }
    },
    data: () => ({
        grupo: {},
        subgrupos: [],
        subgruposFiltered: [],
        indeterminate: false,
        selectedAll: false,
    }),
    methods: {
        open(grupo) {

            this.grupo = grupo
            this.subgrupos = this.clone(grupo.subgrupos)
            this.subgruposFiltered = this.clone(this.subgrupos)

            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        selectAll(permitido) {

            this.subgrupos
                .filter(sg => this.subgruposFiltered.find(sgf => sgf.id === sg.id))
                .filter(sg => !sg.hasPermissaoRequisicao)
                .map(sg => sg.permiteControlar = permitido)
        },
        save() {

            const semPermissoes = !this.subgrupos.find(sg => sg.permiteControlar)

            if (!this.grupo.hasPermissaoRequisicao && this.grupo.permiteControlar && semPermissoes) {

                this.showConfirmation(
                    `Deseja remover a permissão do grupo ${this.grupo.nome}?`,
                    async () => this.handleSave(false),
                    async () => this.handleSave(true)
                )

                return
            }

            this.handleSave(this.grupo.permiteControlar || (!this.grupo.permiteControlar && !semPermissoes))
        },
        handleSave(permissaoGrupo) {

            this.grupo.permiteControlar = permissaoGrupo
            this.grupo.subgrupos = this.clone(this.subgrupos)

            this.$refs.Modal.hide()
        },
        handleSelectAllStatus() {

            this.indeterminate = false

            const subgruposFiltered = this.subgrupos
                .filter(sg => this.subgruposFiltered.find(sgf => sgf.id === sg.id))

            const quantidadePermitida = subgruposFiltered.filter(sg => sg.permiteControlar).length

            this.selectedAll = quantidadePermitida > 0 && quantidadePermitida == subgruposFiltered.length

            if (quantidadePermitida > 0 && quantidadePermitida != subgruposFiltered.length) {

                this.indeterminate = true
            }
        }
    },
    mixins: [object],
    watch: {
        subgrupos: {
            deep: true,
            handler() {

                this.handleSelectAllStatus()
            }
        },
        subgruposFiltered() {

            this.handleSelectAllStatus()
        }
    }
}
</script>